// Минимальный SVG sparkline — линейный мини-график рядом с числом.
// Без осей, без меток. 6-12 точек.

type Props = {
  values: number[]; // абсолютные числа (или 0)
  width?: number;
  height?: number;
  color?: string; // CSS variable / hex
  fillUnder?: boolean; // полупрозрачная заливка под линией
  thickness?: number;
};

export function Sparkline({
  values,
  width = 60,
  height = 20,
  color = 'var(--accent)',
  fillUnder = true,
  thickness = 1.5,
}: Props): JSX.Element {
  if (values.length === 0) {
    return <svg width={width} height={height} aria-hidden="true" />;
  }
  const max = Math.max(...values, 1);
  const stepX = values.length > 1 ? width / (values.length - 1) : 0;

  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - (v / max) * (height - 2) - 1;
    return [x, y] as [number, number];
  });

  const path = points
    .map(([x, y], i) => `${i === 0 ? 'M' : 'L'} ${x.toFixed(2)} ${y.toFixed(2)}`)
    .join(' ');

  const lastPoint = points[points.length - 1];
  const fillPath = fillUnder
    ? `${path} L ${lastPoint?.[0].toFixed(2) ?? width} ${height} L 0 ${height} Z`
    : '';

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
      {fillUnder ? <path d={fillPath} fill={color} opacity={0.15} /> : null}
      <path
        d={path}
        fill="none"
        stroke={color}
        strokeWidth={thickness}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
